/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Link } from "react-router-dom";
import { ReactComponent as LangleyLogo } from "cms/assets/images/TOL-logo.svg";
import { HeaderMenu } from "components/header/header-nav-bar/header-menu";
import { MobileMenu } from "components/header/header-nav-bar/mobile-menu";

const HeaderNavBar = () => {

    return (
        <div className="langley-header-nav-bar">
            <div className='header-nav-bar-container'>
                <Link to='/' className='tol-logo'>
                    <LangleyLogo alt='tol-logo' />
                </Link>
                <HeaderMenu />
                <MobileMenu />
            </div>
        </div>
    );
};

export { HeaderNavBar };
